var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.964,
    height: 212.057,
    viewBox: "0 0 237.964 212.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-Commerce",
    transform: "translate(0 -27.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M225.182,45.161h-62.7c-.066,0-.13.006-.2.01a64.124,64.124,0,0,0-7.4-5.982,3.486,3.486,0,1,0-3.967,5.733,56.663,56.663,0,1,1-14.153-7.11,3.486,3.486,0,1,0,2.228-6.606,64,64,0,1,0,29.685,20.925h56.507a5.816,5.816,0,0,1,5.81,5.81V167.654H203.421a3.486,3.486,0,1,0,0,6.972h27.571v18.306a5.816,5.816,0,0,1-5.81,5.81H12.781a5.816,5.816,0,0,1-5.81-5.81V174.626H185.865a3.486,3.486,0,1,0,0-6.972H6.972V57.943a5.816,5.816,0,0,1,5.81-5.81H54.35a3.486,3.486,0,0,0,0-6.972H12.781A12.8,12.8,0,0,0,0,57.943V192.932a12.8,12.8,0,0,0,12.781,12.781H89.188v27.242H78.665a3.486,3.486,0,1,0,0,6.972h79.782a3.486,3.486,0,1,0,0-6.972H147.923V205.713h77.259a12.8,12.8,0,0,0,12.781-12.781V57.943a12.8,12.8,0,0,0-12.781-12.781Zm-84.23,187.794H96.16V205.713h44.792Z",
    transform: "translate(0 0)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M183.888,97.657a8.356,8.356,0,0,0-8.205-6.8h-3.727a3.486,3.486,0,1,0,0,6.972h3.727a1.379,1.379,0,0,1,1.354,1.123l10.316,54.641a3.486,3.486,0,0,0,3.425,2.839h2.352a6.505,6.505,0,1,0,9.689,0h14.34a6.505,6.505,0,1,0,9.689,0h3.137a3.486,3.486,0,0,0,0-6.972H193.667l-1.422-7.533H231.2a3.486,3.486,0,0,0,3.425-2.837l6.187-32.64c0-.021.008-.042.011-.063a4.191,4.191,0,0,0-4.131-4.9H184.612Zm5.2,27.536h9.51l.713,9.76h-8.38Zm24.892,0-.713,9.76H206.3l-.713-9.76Zm-8.9-6.972-.713-9.76H215.2l-.713,9.76Zm15.179,16.732.713-9.76h9.2l-1.85,9.76Zm11.23-16.732H221.48l.713-9.76h11.144Zm-34.113-9.76.713,9.76H187.771l-1.843-9.76Z",
    transform: "translate(-90.17 -33.711)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M44.837,267.073H65.455a3.486,3.486,0,1,0,0-6.972H44.837a3.486,3.486,0,1,0,0,6.972Z",
    transform: "translate(-22.132 -124.296)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M44.837,300.9H83.308a3.486,3.486,0,1,0,0-6.972H44.837a3.486,3.486,0,1,0,0,6.972Z",
    transform: "translate(-22.132 -142.403)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M426.852,108.37a3.485,3.485,0,0,0-3.486,3.486v8.724h-8.724a3.486,3.486,0,1,0,0,6.972h8.724v8.724a3.486,3.486,0,0,0,6.972,0v-8.724h8.724a3.486,3.486,0,1,0,0-6.972h-8.724v-8.724a3.486,3.486,0,0,0-3.486-3.486Z",
    transform: "translate(-220.062 -43.086)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/E-Commerce.c8d480a973154a057e0372f6f345aa97.svg";
export { ForwardRef as ReactComponent };